export default "__VITE_ASSET__a68f8f3b__"